<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 sm10 offset-sm1>
   			<v-form v-model="validForm">
          <v-card>
            <v-card-title class="px-4">
              <v-flex xs6 sm3>
                <div class="subheading text-uppercase font-weight-light">
                  <span>Production ID : </span>
                  <span>{{production.id}}</span>
                </div>
              </v-flex>
              <v-flex xs6 sm6 class="text-xs-center">
                <span class="headline text-uppercase font-weight-light pt-4" v-text="`${pageType} Production`"></span>
              </v-flex>
              <v-flex xs6 sm3 class="text-xs-right">
                <div class="body-2 font-weight-light py-2 pl-5">
                  <v-dialog v-if="!viewMode" ref="dialog" v-model="dateModal" :return-value.sync="production.date" persistent lazy full-width width="290px">
                    <v-text-field slot="activator" v-model="production.date" label="Production Date" prepend-icon="event" readonly :disabled="viewMode"
                    ></v-text-field>
                    <v-date-picker v-model="production.date" @input="$refs.dialog.save(production.date)" :max="maxDate" :min="minDate"></v-date-picker>
                  </v-dialog>
                  <v-text-field v-else v-model="production.date" label="Production Date" prepend-icon="event" readonly
                    ></v-text-field>
                </div>
              </v-flex>
            </v-card-title>

            <v-card-text>

              <div class="subheading text-uppercase px-4">Raw Materials</div>

              <v-container grid-list-md py-0 v-if="!viewMode">
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-autocomplete :loading="rawMaterialLoading" v-model="rawMaterialId" :search-input.sync="rawMaterialSearch" :items="rawMaterials" item-text="title" item-value="id" label="Search Raw Material" hide-no-data>
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 class="hidden-sm-and-up"><!-- only one factory - so hiding -->
                    <v-autocomplete :rules="requireRule" v-model="production.factory" :items="factories" item-text="title" item-value="id" label="Factory"></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <div>
                      <div class="v-table__overflow">
                        <table class="v-datatable v-table">
                          <thead>
                            <tr>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Name</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Unit</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!viewMode">
                                <span>Actions</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="production.rawMaterials && production.rawMaterials.length > 0">
                            <tr is="production-rawmaterial-item" v-for="(item, index) in production.rawMaterials" v-bind:item="item" v-bind:index="index" v-on:delete="deleteRawMaterial" :viewMode="viewMode"></tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="8">No Items Added</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-divider class="mb-4"></v-divider>

              <div class="subheading text-uppercase pt-2 px-4">Final Products</div>

              <v-container grid-list-md py-0 v-if="!viewMode && (!production.items || production.items.length == 0)">
                <v-layout wrap>
                  <v-flex xs5>
                    <v-autocomplete :loading="itemCodeLoading" v-model="itemId" :search-input.sync="itemCodeSearch" :items="searchItems" item-text="item_code" item-value="id" label="Search Item Code" hide-no-data>
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title v-text="data.item.item_code"></v-list-tile-title>
                          <v-list-tile-sub-title class="caption" v-text="data.item.category_name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs7>
                    <v-autocomplete :loading="itemNameLoading" v-model="itemId" :search-input.sync="itemNameSearch" :items="searchItems" item-text="title" item-value="id" label="Search Item Name" hide-no-data>
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                          <v-list-tile-sub-title class="caption" v-text="data.item.category_name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <div>
                      <div class="v-table__overflow">
                        <table class="v-datatable v-table">
                          <thead>
                            <tr>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Code</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Name</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Unit</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!viewMode">
                                <span>Actions</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="production.items && production.items.length > 0">
                            <tr is="production-item" v-for="(item, index) in production.items" v-bind:item="item" v-bind:index="index" v-on:delete="deleteItem" :viewMode="viewMode"></tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="8">No Items Added</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>

            <v-card-actions v-if="!viewMode">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat :disabled="processing" to="/production-list">Cancel</v-btn>
              <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="production.id ? updateProduction() : saveProduction()" v-text="production.id ? 'Update' : 'Save'"></v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>
  
  import ProductionItem from './ProductionItem'
  import ProductionRawMaterialItem from './ProductionRawMaterialItem'

  export default {
    name: 'Production',
    props: {
      viewMode: {
        default: false
      }
    },
    data () {
      return {
      	title: "Production",
        dateModal: false,
        validForm: false,
      	processing: false,
        rawMaterialLoading: false,
        rawMaterialId: null,
        rawMaterialSearch: "",
        rawMaterials: [],
        itemNameLoading: false,
        itemId: null,
        itemNameSearch: "",
        itemCodeLoading: false,
        itemCodeSearch: "",
        searchItems: [],
        production: {},
        maxDate: this.today('YYYY-MM-DD'),
        minDate: this.formatMysqlDate(Date.now() - ( 1000 * 60 * 60 * 24 * 6 ), 'YYYY-MM-DD'),//before 1 week
        factories: [],
        defaultProduction: {
          id: "",
          date: this.today('YYYY-MM-DD'),
          items: [],
          rawMaterials: [],
          factory: this.getDefault('factory'),
        },
        nameRules: [
            v => !!v || 'Name is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        requireRule: [
          v => !!v || 'Field is required'
        ]

      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Production',
            disabled: false,
            href: '/production-list'
	        },
	        {
	          text: this.viewMode ? 'View' : this.$route.params.id ? 'Edit' : 'Add',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Production')
    },
    methods: {

      searchItemsByName () {
        let api_path = `${this.config.apis.searchItems}?title=${this.itemNameSearch}`
        this.itemNameLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.itemNameLoading = false
            if (this.isSuccessResponse(response)) {
              this.searchItems = response.data.data
            }
        })
        .catch((error) => {
            this.itemNameLoading = false
        })
      },

      searchItemsByCode () {
        let api_path = `${this.config.apis.searchItems}?item_code=${this.itemCodeSearch}`
        this.itemCodeLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.itemCodeLoading = false
            if (this.isSuccessResponse(response)) {
              this.searchItems = response.data.data
            }
        })
        .catch((error) => {
            this.itemCodeLoading = false
        })
      },

      searchRawMaterialsByName () {
        this.rawMaterialLoading = true
        this.axios.get(`${this.config.apis.searchRawMaterials}?title=${this.rawMaterialSearch}`)
        .then((response) => {
            this.rawMaterialLoading = false
            if (this.isSuccessResponse(response)) {
              this.rawMaterials = response.data.data
            }
        })
        .catch((error) => {
            this.rawMaterialLoading = false
        })
      },

      upsertItemFromListToProduction (val) {

        let exist = this.production.items.findIndex(item => item.item_id === val)

        // if item already exists, then increase quantity else add new item
        if (exist !== -1) {
          this.production.items[exist].quantity++
          this.clearItemAutoComplete()
        }
        else{
          let item = this.searchItems.filter(item => item.id === val)

          if (item.length > 0) {
            //add new item at the first index of items array
            let new_item = this.extend({quantity:1, item_id: item[0].id}, item[0])
            delete new_item.id
            this.production.items.splice(0, 0, new_item)
            this.clearItemAutoComplete()
          }
        }

      },

      upsertRawMaterialToProduction (val) {

        let exist = this.production.rawMaterials.findIndex(item => item.item_id === val)

        // if item already exists, then increase quantity else add new item
        if (exist !== -1) {
          this.production.rawMaterials[exist].quantity++
          this.clearRawMaterialAutoComplete()
        }
        else{
          let item = this.rawMaterials.filter(item => item.id === val)

          if (item.length > 0) {
            //add new item at the first index of items array
            let new_item = this.extend({quantity:1, item_id: item[0].id}, item[0])
            delete new_item.id
            this.production.rawMaterials.splice(0, 0, new_item)
            this.clearRawMaterialAutoComplete()
          }
        }

      },

      clearItemAutoComplete () {
        this.itemNameSearch = ""
        setTimeout(() => {
          this.itemId = null
        }, 100)
      },

      clearRawMaterialAutoComplete () {
        this.rawMaterialSearch = ""
        setTimeout(() => {
          this.rawMaterialId = null
        }, 100)
      },

      saveProduction () {

        if (this.production.items.length === 0) return this.notifyError('emptyProductionItems')
        if (this.production.rawMaterials.length === 0) return this.notifyError('emptyProductionMaterials')

        this.processing = true

        let data = this.extend(this.production)

        this.axios.post(this.config.apis.saveProduction, data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.notifySuccess('insertProductionSuccess')
              this.$router.push("/production-list")
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      updateProduction () {
      	
        if (this.production.items.length === 0) return this.notifyError('emptyProductionItems')
        if (this.production.rawMaterials.length === 0) return this.notifyError('emptyProductionMaterials')

        this.processing = true

        let data = this.extend(this.production)

        this.axios.put(this.config.apis.updateProduction.replace(":id", data.id), data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.notifySuccess('updateProductionSuccess')
              this.$router.push("/production-list")
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      deleteItem (index) {
        this.production.items.splice(index, 1)
      },

      deleteRawMaterial (index) {
        this.production.rawMaterials.splice(index, 1)
      },

      initNewProduction () {
        this.production = this.extend({}, this.defaultProduction)
      },

      loadProduction (id) {
        this.processing = true
        this.axios.get(this.config.apis.getProduction.replace(":id", id))
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.production = response.data.data
              this.taxEnabled = this.production.tax_percent > 0
            }
            else{
              this.production = this.initNewProduction()
            }
          })
          .catch((error) => {
            this.processing = false
          })
      }

    },
    mounted () {

      this.getAllData('factory')
        .then((response) => {
          this.factories = response
        })

      if (this.$route.params.id) {
        this.loadProduction(this.$route.params.id)
      }
      else{
        this.initNewProduction()
      }
      
    },

    computed: {

      pageType () {
        return this.viewMode ? 'View' : this.$route.params.id ? 'Update' : 'Add'
      }

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.id) {
          this.loadProduction(to.params.id)
        }
        else{
          this.production = this.initNewProduction()
        }

      },

      itemCodeSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchItemsByCode()
        }
      },

      itemNameSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchItemsByName()
        }
      },

      rawMaterialSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchRawMaterialsByName()
        }
      },

      itemId (val, oldVal) {
        if (val && val !== oldVal) {
          this.upsertItemFromListToProduction(val)
        }
      },

      rawMaterialId (val, oldVal) {
        if (val && val !== oldVal) {
          this.upsertRawMaterialToProduction(val)
        }
      }

    },
    
    components: {
      'production-item': ProductionItem,
      'production-rawmaterial-item': ProductionRawMaterialItem
    }

  }
</script>
